<template>
  <div :class="divWidthChange" class="conteudoWidth">
    <div class="row">
      <div class="col-sm-6">
        <span class="titlePage">{{ titlePage }}</span>
      </div>
      <div class="col-sm-6 text-right"></div>
    </div>
    <hr />
    <div class="row">
      <div class="col-sm-12">
        <fccTable
          striped
          hover
          :fields="fieldsAreaFormacao"
          responsive
          :porPage="itemPorPage"
          search
          pagination
          fieldVisibility
          pdf
          csv
          xls
          :titlePage="titlePage"
          :titlePDF="titlePDF"
          :actions="actionsAreaFormacao"
          addFilter
          :items="listarAreaFormacao"
        >
        </fccTable>
      </div>
    </div>
    <fccModal
      centered
      idModal="editArea"
      size="xl"
      :titleModal="titleModal"
      escondeFooter
      travaEsc
      travaBack
    >
      <form
        @submit.prevent="areaFormacao.id === 0 ? addAreaFormacao() : editAreaFormacao()"
        autocomplete="off"
      >
        <div class="row innerPage">
          <div class="col-sm-12">
            <input v-model="areaFormacao.id" type="hidden" />
            <fccInput extraClasses="inputLabel" v-model="areaFormacao.codareaformacao" required
              >Código</fccInput
            >
          </div>
        </div>
        <div class="row innerPage">
          <div class="col-sm-12">
            <fccInput extraClasses="inputLabel" v-model="areaFormacao.descricao"
              >Descrição</fccInput
            >
          </div>
        </div>
        <div class="row innerPage">
          <div class="col-sm-12 text-right">
            <fccButton classeAdd="form-control" tipo="submit">{{ labelsSystem.salvar }}</fccButton>
          </div>
        </div>
      </form>
    </fccModal>
  </div>
</template>
<script>
import axios from 'axios'
import store from '@/store'

export default {
  data() {
    return {
      sortBy: 'ordem',
      titlePage: 'Área de formação',
      titleModal: '',
      titlePDF: 'Área de formação',
      listarAreaFormacao: [],
      baseUrlGestaoProjetosConcurso: '',
      areaFormacao: [],
      itemPorPage: '100',
      actionsAreaFormacao: [
        {
          button: true,
          funcaoButton: 'editArea',
          icon: 'edit',
          tooltip: 'Editar',
          objpermCodigo: store.state.permissaoMenu.editar
        },
        {
          button: true,
          funcaoButton: 'deleteAreaFormacao',
          icon: 'trash',
          tooltip: 'Excluir',
          objpermCodigo: store.state.permissaoMenu.excluir
        }
      ],
      fieldsAreaFormacao: [
        { key: 'id', label: 'ID', sortable: true, active: true },
        { key: 'codareaformacao', label: 'Código', sortable: true, active: true },
        { key: 'descricao', label: 'Descrição', sortable: true, active: true },
        { key: 'actions', label: '', tdClass: 'no-print', thClass: 'no-print', active: true }
      ]
    }
  },
  methods: {
    listandoAreaFormacao: function () {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          this.baseUrlGestaoProjetosConcurso + 'AreaFormacao/Listar',
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.listarAreaFormacao = response.data
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    addField: function () {
      this.titleModal = 'Adicionar Área de formação'
      this.areaFormacao = {}
      this.areaFormacao.id = 0
      this.$root.$emit('bv::show::modal', 'editArea')
    },
    editArea: function (_, item) {
      this.titleModal = 'Editar Área de formação'
      this.areaFormacao = item
      this.$root.$emit('bv::show::modal', 'editArea')
    },
    editAreaFormacao: function () {
      this.carregaTexto(this.codeMensagem('C03'))
      axios
        .put(
          this.baseUrlGestaoProjetosConcurso + 'AreaFormacao/Alterar',
          this.areaFormacao,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.areaFormacao = {}
          this.callToast(this.mensagensUpdate.editado, 'success')
          this.$root.$emit('bv::hide::modal', 'editArea')
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto())
    },
    addAreaFormacao: function () {
      this.carregaTexto(this.codeMensagem('C03'))
      axios
        .post(
          this.baseUrlGestaoProjetosConcurso + 'AreaFormacao/Adicionar',
          this.areaFormacao,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.areaFormacao = {}
          this.listandoAreaFormacao()
          this.callToast(this.mensagensUpdate.adicionado, 'success')
          this.$root.$emit('bv::hide::modal', 'editArea')
        })
        .catch((error) => {
          this.setErrorSystem(error)
        })
        .finally(this.carregaTexto())
    },
    deleteAreaFormacao: function (_, item) {
      this.callConfirm(this.mensagemExcluir, item.descricao).then((result) => {
        if (result.value) {
          this.carregaTexto(this.codeMensagem('C03'))
          axios
            .delete(
              this.baseUrlGestaoProjetosConcurso + 'AreaFormacao/Excluir/' + item.id,
              this.dadosLoginSession.fccTokenHeaders
            )
            .then(() => {
              this.listandoAreaFormacao()
              this.callToast(this.mensagensUpdate.excluido, 'success')
            })
            .catch((error) => {
              this.setErrorSystem(error)
            })
            .finally(this.carregaTexto())
        }
      })
    }
  },
  mounted: function () {
    this.baseUrlGestaoProjetosConcurso = store.state.baseUrlGestaoProjetos
    this.listandoAreaFormacao()
  }
}
</script>
